import {
	Button,
	TextField,
	Tooltip,
	FormControlLabel,
	Checkbox,
} from "@material-ui/core";
import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { ArrowDownward, ArrowUpward, Delete, Edit, LocalDining } from "@material-ui/icons";
import _ from 'lodash';
import ConfirmDialog from "../app/components/dialogs/ConfirmDialog";
import MyAutocomplete from "../app/components/MyAutocomplete";
import Table, { buttonsStyle } from "../app/components/tables/table";
import { formatFloat } from "./helpers";
import { calcUnitsNt, deleteBlockRecipesFromBD, descriptionFormatter, getType, reCalcNutritionalValues, styleFormat } from "./structuresCalcs";
import { getUserStructuresById } from "../api/userStructures";
import { getUserDietsById } from "../api/userDiets";
import { alertError } from "./logger";
import { Card, CardBody } from "../_metronic/_partials/controls";
import { formattedValueNumber } from "./numbers";
import { setChanges } from "./globals";

export function reqFormat(req, type, structure, selectedNtOption, patient) {
    if (!req) return "";
    const min = parseFloat(calcUnitsNt(
        req.min, selectedNtOption.value, type, 
        structure?.requeriments, 
        patient?.selectedWeight || 1
    ))
    const max = parseFloat(calcUnitsNt(
        req.max, selectedNtOption.value, type, 
        structure?.requeriments, 
        patient?.selectedWeight || 1
    ))
    const fixed = selectedNtOption.value !== "g/kg" ? 0 : 1;
    return `${min.toFixed(fixed)} - ${max.toFixed(fixed)}`;
}

const ntOptions = [
    { _id: 3, value: "g"},
    { _id: 1, value: "g/kg"},
    { _id: 2, value: "%"},
];

export const DietInfo = (props) => {
    const { 
        openConfirmDialog, setOpenConfirmDialog, selectedStructure,
        setRefresh, refresh, userDiet, setUserDiet, blocks, setBlocks,
        setOpenEditBlockDialog, setSelectedBlock, structure, setStructure,
        setIsMeal, setSelectedDeleteBlock, saveDiet, disableLoadingData,
        dataNt, dataBlocks, updateSt, allFoods,
        selectedDeleteBlock, structuresOptions, structureHasChanged,
        setSelectedStructure, patient, deleteDiet, userBodyWeights
    } = props;

    const [selectedNtOption, setSelectedNtOption] = useState(ntOptions[0]);

	const numbersHeaderStyle = { width: '80px' };

    const blockColumns = [
		{ 
            dataField: "name",
            text: "Full Name",
			style: styleFormatter,
            headerStyle: { width: "200px" }
        },
		{
			dataField: "description",
			text: "description",
			formatter: (cell, row) => descriptionFormatter(cell, row, allFoods),
			style: styleFormatter,
		},
		{
			dataField: "kcals",
			text: "kcal",
			style: styleFormatter,
			formatter: numbersFormatter,
			align: 'center',
			headerStyle: numbersHeaderStyle,
			headerAlign: 'center',
		},
		{
			dataField: "carbohydrates",
			text: `cho (${selectedNtOption.value})`,
			style: styleFormatter,
			formatter: numbersFormatter,
			align: 'center',
			headerStyle: numbersHeaderStyle,
			headerAlign: 'center',
		},
		{
			dataField: "proteins",
			text: `pro (${selectedNtOption.value})`,
			style: styleFormatter,
			formatter: numbersFormatter,
			align: 'center',
			headerStyle: numbersHeaderStyle,
			headerAlign: 'center',
		},
		{
			dataField: "fats",
			text: `fat (${selectedNtOption.value})`,
			style: styleFormatter,
			formatter: numbersFormatter,
			align: 'center',
			headerStyle: numbersHeaderStyle,
			headerAlign: 'center',
		},
		{
			dataField: "fiber",
			text: "fiber",
			style: styleFormatter,
			formatter: numbersFormatter,
			align: 'center',
			headerStyle: numbersHeaderStyle,
			headerAlign: 'center',
		},
		{
			dataField: "number",
			text: "",
			formatter: blocksButtonFormatter,
			align: 'right',
			headerStyle: { width: '200px'},
			style: styleFormatter
		}
	];

    // function descriptionFormatter(cell, row) {
    //     console.log(cell, row);
    //     return cell;
    // }

	function styleFormatter(cell, row) {
		const block = blocks?.find((x) => x.number === row.number);
		return styleFormat(block);
	}

	function numbersFormatter(cell) { return parseFloat(cell || 0).toFixed(1);}

    function typeFormatter(cell) {
		const block = blocks.find((x) => cell === x.number);
		return (block?.isIntake? block?.intake.isSnack? "Snack" : "Main" : "Exercise");
	}

    function blocksButtonFormatter(cell) {
		const index = structure.blocks.findIndex((x) => x.number === cell);
		const block = structure.blocks[index];

		return (
			<>
				<Tooltip title="Edit">
					<Button
						style={buttonsStyle}
						size="small"
						onClick={() => {
							setOpenEditBlockDialog(true);
							setSelectedBlock(block);
							setIsMeal(block.isIntake);
						}}
					>
						<Edit />
					</Button>
				</Tooltip>
				<Tooltip title="Move up">
					<Button
						size="small"
						style={buttonsStyle}
						disabled={index === 0}
						onClick={() => blockMove(block, index, index-1)}
					>
						<ArrowUpward />
					</Button>
				</Tooltip>
				<Tooltip title="Move down">
					<Button
						size="small"
						disabled={
							index >= (blocks?.length - 1 || 0)
						}
						style={buttonsStyle}
						onClick={() => blockMove(block, index, index+1)}
					>
						<ArrowDownward />
					</Button>
				</Tooltip>
				<Tooltip title="Delete">
					<Button
						style={buttonsStyle}
						size="small"
						onClick={() => {
							setOpenConfirmDialog(4)
							setSelectedDeleteBlock(index);
						}}
					>
						<Delete />
					</Button>
				</Tooltip>
			</>
		)
	}

    function sortByNumber(a, b) {
        if (a.number < b.number) return -1;
        if (a.number > b.number) return 1;
        return 0;
    }

    function blockMove(block, index, newIndex) {
		let blocks = [
			...structure.blocks
		]
        blocks[newIndex].number = index;
        blocks[index].number = newIndex;
        blocks.sort(sortByNumber);

		const data = reCalcNutritionalValues(blocks, patient);
		const newStructure = {
			...structure,
			kcal: data.kcals,
			carbohydrates: data.carbohydrates,
			protein: data.protein,
			fats: data.fats,
			fatskg: data.fatskg,
			fatspercent: data.fatspercent,
			blocks: blocks,
			requeriments: data.requeriments,
			reqCho: data?.reqCho,
			reqPro: data?.reqPro,
			reqFat: data?.reqFat
		}

		setStructure(newStructure);
		setBlocks(blocks);
		saveDiet(newStructure)
		setRefresh(true);
	}

    function getData(blocks) {

        function formatNameIntake(block, blocks) {
            const name = block?.name;
            // return name;
            const isSnack = (block?.intake?.isSnack);
            if (!isSnack) return name;
            const blockIndex = blocks?.findIndex((x) => x.number === block.number);
            let sumDown = 0, sumUp = 0;
            for (let i = blockIndex-1; i >= 0; i--) { 
            const actB = blocks[i];	
            if (actB?.name === name && actB?.intake?.isSnack) sumDown++; 
            else break;
            }
            for (let i = blockIndex+1; i < blocks.length; i++) { 
            const actB = blocks[i];	
            if (actB?.name === name && actB?.intake?.isSnack) sumUp++; 
            else break;
            }
            if ((sumDown + sumUp) > 0) {
            if (sumUp === 0 && sumDown%3 === 0) return name;
            return `${block.name} (Option ${(sumDown%3)+1})`;
            }
            return name;
        }


        let data = [];

        for (const block of blocks) {
            let elem = {...block, name: formatNameIntake(block, blocks)};
            const type = getType(elem);
            if (type === "Exercise") {
                elem.kcals = (block?.exercise?.activities?.totalGCho || 0) * 4;
                elem.carbohydrates = block?.exercise?.activities?.totalGCho || 0;
                elem.fats = 0;
            }
            else {
                elem.carbohydrates = calcUnitsNt(elem?.carbohydrates || 0, selectedNtOption.value, "carbohydrates", elem.kcals, patient.selectedWeight || 1);
                elem.proteins = calcUnitsNt(elem?.proteins || 0, selectedNtOption.value, "proteins", elem.kcals, patient.selectedWeight || 1);
                elem.fats = calcUnitsNt(elem?.fats || 0, selectedNtOption.value, "fats", elem.kcals, patient.selectedWeight || 1);
            }
            data.push({...elem});
        }

        return data;
    }

    function changeStructure(structureId) {
        getUserStructuresById(structureId)
			.then((res) => {
				if (res.status === 200) {
					let structureData = {...res.data};

					let blocks = [...structureData?.blocks];
					
					if (blocks?.length > 0) {
						for (let i = 0; i < blocks?.length; ++i) {
							let block = blocks[i];
							let recipes = block?.intake?.recipes;
							if (recipes?.length > 0) {
								// structureData.block[i].id = i;
								for (let j = 0; j < recipes?.length; ++j) {
									let actR = recipes[j];
									delete actR.recipe._id;
									actR.recipe.typeStructure = "userDiet"
									recipes[j] = actR;
								}
								block.recipes = recipes;
							}
							blocks[i] = block;
						}
					}
					
					structureData.blocks = blocks;
					setBlocks(structureData?.blocks);
					saveDiet(structureData)
					setStructure(structureData);
					disableLoadingData();
				}
			})
			.catch((error) => {
				alertError({
					error: error,
					customMessage: "Could not get structure.",
				});
				//history.push("/structures");
			});
    }

	async function refreshStructure(structure) {
		const diet = {
			...userDiet,
			diet: {...structure}
		}
		await updateSt(diet); //debe ser diet
		const data = await getUserDietsById(diet?._id)
			.catch((error) => {
				alertError({
					error: error,
					customMessage: "Could not get user structures information, please recharge the page."
				})
			})
		
		const saveStructure = data?.data?.diet || structure;
		const newBlocks = saveStructure?.blocks;
		
		setBlocks([...newBlocks])
		saveDiet({...data?.data?.diet});
		setChanges(-1);
	}

	async function deleteBlock(index) {
		const res = await deleteBlockRecipesFromBD(userDiet.diet, index);
		if (res) {
			let newBlocks = structure?.blocks ? [...structure?.blocks] : [];
			newBlocks.splice(index, 1);

			for (let i = index; i < newBlocks?.length; ++i) newBlocks[i].number = i;

			const data = reCalcNutritionalValues(newBlocks, patient);

			const newStructure = {
				...structure,
				kcal: data.kcals,
				carbohydrates: data.carbohydrates,
				protein: data.protein,
				fats: data.fats,
				fatskg: data.fatskg,
				fatspercent: data.fatspercent,
				blocks: newBlocks,
                requeriments: data.requeriments,
                reqCho: data?.reqCho,
                reqPro: data?.reqPro,
                reqFat: data?.reqFat
			}

			setBlocks([...newBlocks]);
			setSelectedBlock(-1);
			if (userDiet?._id) refreshStructure(newStructure);
			else {
				saveDiet({...newStructure})
				setStructure({...newStructure});
			}
			setRefresh(true);
		}
	}

    const handleChange = (element) => (event) => {
        const { value } = event.target;
        const formattedValue = formattedValueNumber(value, true);
        setUserDiet({...userDiet, [element]: formattedValue})

		setRefresh(true);
	};

    function isEqualDate(ddate1, ddate2) {
		const date1 = new Date(ddate1), date2 = new Date(ddate2);
		const d1Y = date1.getFullYear(), d1M = date1.getMonth(), d1D = date1.getDate();
		const d2Y = date2.getFullYear(), d2M = date2.getMonth(), d2D = date2.getDate();
		if (d1Y === d2Y && d1M === d2M && d1D === d2D) return true;
		return false;
	}

    return (
        <>
            <Card>
                <ConfirmDialog
                    title={
                    "Are you sure you want to change the structure? You will lose all your changes"
                    }
                    open={openConfirmDialog === 1}
                    setOpen={setOpenConfirmDialog}
                    onConfirm={() => {
                        changeStructure(selectedStructure._id);
                        setRefresh(true);
                        setOpenConfirmDialog(-1);
                    }}
                />
                <ConfirmDialog
                    title={
                    "Are you sure you want to delete the diet?"
                    }
                    open={openConfirmDialog === 3}
                    setOpen={setOpenConfirmDialog}
                    onConfirm={() => {
                        deleteDiet(userDiet);
                    }}
                />

                {/* <ConfirmDialog
                    title={
                    "Are you sure you want to change the competition? You will lose all your changes"
                    }
                    open={openConfirmDialog === 2}
                    setOpen={setOpenConfirmDialog}
                    onConfirm={() => {
                        actualizeCompetition(selectedCompetition)
                        setOpenConfirmDialog(-1);
                    }}
                /> */}
                <ConfirmDialog
                    title={
                        "Are you sure you want to delete the block? You will lose all your block information"
                    }
                    open={openConfirmDialog === 4}
                    setOpen={setOpenConfirmDialog}
                    onConfirm={() => {
                        deleteBlock(selectedDeleteBlock)
                    }}
                />
                <CardBody>
                    <Row>
                        <Col>
						<TextField
							id={"weight"}
							label={"Weight (kg)"}
							value={(userBodyWeights?.find((x) => isEqualDate(x.date, userDiet?.date)))?.weight || ""}
							// onChange={handleChange('weight')}
							InputLabelProps={{shrink: true}}
							margin="normal"
							variant="standard"
							type="number"
							inputProps={{ readOnly: true }}
							className='readonly'
						/>
                        </Col>
                    </Row>
                    <br />
                    <h3> Diet of the day (provisional) </h3>
                    
                    {(!userDiet?._id || structure?.blocks?.length === 0) && (
                        <>
                            <MyAutocomplete
                                options={ structuresOptions }
                                getOptionLabel={(option) =>
                                    option.name
                                }
                                value={ structuresOptions.find(option => option._id === structure?._id) || null }
                                onChange={(event, selected) => {
                                    if (structureHasChanged && structure?.blocks?.length !== 0 && structure) {
                                        setOpenConfirmDialog(1)
                                        setSelectedStructure(selected);
                                    } else {
                                        changeStructure(selected._id);
                                        setRefresh(true);
                                    }
                                }}
                                placeholder="Select structure"
                                label={"Type of structure"}
                            />
                        </>
                    )}

                    <Row>
                        <Col>
                            <MyAutocomplete
                                options={ ntOptions }
                                getOptionLabel={(option) =>
                                    option.value
                                }
                                value={ ntOptions.find((option) => option._id === selectedNtOption?._id) || null }
                                onChange={(event, selected) => {
                                    setSelectedNtOption(selected);
                                }}
                                placeholder="Select units"
                                label={"Type of units"}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col >
                            <TextField
                                id={`requerimentsKcals`}
                                label={`Requirements KCAL`}
                                value={structure?.requeriments}
                                InputLabelProps={{
                                shrink: true
                                }}
                                margin="normal"
                                variant="standard"
                                required
                                type="number"
                                className='readonly'
                            />
                        </Col>
                        <Col >
                            <TextField
                                id={`carbohydrates`}
                                label={`Requirements CHO (${selectedNtOption.value})`}
                                value={reqFormat(structure?.reqCho, "carbohydrates", structure, selectedNtOption, patient)}
                                InputLabelProps={{
                                shrink: true
                                }}
                                margin="normal"
                                variant="standard"
                                required
                                type="text"
                                className='readonly'
                            />
                        </Col>
                        <Col >
                            <TextField
                                id={`protein`}
                                label={`Requirements PRO (${selectedNtOption.value})`}
                                value={reqFormat(structure?.reqPro, "proteins", structure, selectedNtOption, patient)}
                                InputLabelProps={{
                                shrink: true
                                }}
                                margin="normal"
                                variant="standard"
                                required
                                type="text"
                                className='readonly'
                            />
                        </Col>
                        <Col >
                            <TextField
                                id={`fats`}
                                label={`Requirements FAT (${selectedNtOption.value})`}
                                value={reqFormat(structure?.reqFat, "fats", structure, selectedNtOption, patient)}
                                InputLabelProps={{
                                shrink: true
                                }}
                                margin="normal"
                                variant="standard"
                                required
                                type="text"
                                className='readonly'
                            />
                        </Col>
                        <Col />
                    </Row>

                    <Row>
                        <Col>
                            <TextField
                                id={`kcals`}
                                label="KCAL"
                                value={formatFloat(dataNt?.kcals || 0)}
                                InputLabelProps={{
                                    shrink: true,
                                    min: 0,
                                }}
                                margin="normal"
                                variant="standard"
                                type="number"
                                className='readonly'
                            />
                        </Col>
                        <Col>
                            <TextField
                                id={`carbohydrates`}
                                label={`CHO (${selectedNtOption.value})`}
                                value={calcUnitsNt(
                                    dataNt?.carbohydrates || 0, 
                                    selectedNtOption.value, 
                                    "carbohydrates", 
                                    dataNt?.kcals, 
                                    patient?.selectedWeight || 1
                                )}
                                InputLabelProps={{
                                    shrink: true,
                                    min: 0,
                                }}
                                margin="normal"
                                variant="standard"
                                type="number"
                                className='readonly'
                            />
                        </Col>
                        <Col>
                            <TextField
                                id={`proteins`}
                                label={`PRO (${selectedNtOption.value})`}
                                value={calcUnitsNt(
                                    dataNt?.proteins || 0, 
                                    selectedNtOption.value, 
                                    "proteins", 
                                    dataNt?.kcals, 
                                    patient?.selectedWeight || 1
                                )}
                                InputLabelProps={{
                                    shrink: true,
                                    min: 0,
                                }}
                                margin="normal"
                                variant="standard"
                                type="number"
                                className='readonly'
                            />
                        </Col>
                        <Col>
                            <TextField
                                id={`fats`}
                                label={`FAT (${selectedNtOption.value})`}
                                value={calcUnitsNt(
                                    dataNt?.fats, 
                                    selectedNtOption.value, 
                                    "fats", 
                                    dataNt?.kcals, 
                                    patient?.selectedWeight || 1
                                )}
                                InputLabelProps={{
                                    shrink: true,
                                    min: 0,
                                }}
                                margin="normal"
                                variant="standard"
                                type="number"
                                className='readonly'
                            />
                        </Col>
                        <Col>
                            <TextField
                                id={`fiber`}
                                label="FIBER"
                                value={formatFloat(dataNt?.fiber || 0)}
                                InputLabelProps={{
                                    shrink: true,
                                    min: 0,
                                }}
                                margin="normal"
                                variant="standard"
                                type="number"
                                className='readonly'
                            />
                        </Col>
                    </Row>
                    <br />
                    <Row>
                        <Col><h3>Structure</h3></Col>
                        <Col className="text-right">
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={() => {
                                    setOpenEditBlockDialog(true);
                                    setSelectedBlock(null);
                                    setIsMeal(false);
                                }}
                            >
                                Add exercise
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary"
                                style={{marginLeft: 10}}
                                onClick={() => {
                                    setOpenEditBlockDialog(true);
                                    setSelectedBlock(null);
                                    setIsMeal(true)
                                }}
                            >
                                Add meal
                            </button>
                        </Col>
                    </Row>
                    {!refresh &&
                        blocks?.length > 0 && structure?.blocks?.length > 0 && (
                            <Table
                                columns={blockColumns}
                                data={getData(dataBlocks)}
                                sizePerPage={20}
                            />
                    )}
                    { refresh && blocks?.length > 0 && structure?.blocks?.length > 0 && (
                        <>
                            {Array(Math.min(structure?.blocks?.length)).fill(0).map((x) => {
                                return (
                                    <>
                                        <br /><br /><br />
                                        {structure?.blocks?.length <= 3 && (<><br /></>)}
                                    </>
                                )
                            })}
                        </>
                    )}

                    {/* <Row>
                        <Col>
                            <TextField
                                id={`gastrointestinalSymptoms`}
                                label="gastrointestinalSymptoms (1 - 5)"
                                value={userDiet?.gastrointestinalSymptoms}
                                InputLabelProps={{
                                    shrink: true,
                                    min: 0,
                                }}
                                margin="normal"
                                placeholder="Not defined by the patient"
                                variant="standard"
                                required
                                type="number"
                                className='readonly'
                            />
                        </Col>
                    </Row> */}
                    <br/><br/><br/><br/><br/>
                </CardBody>
            </Card>
        </>
    )
}

export const NotesInfo = (props) => {
    const { userDiet, setUserDiet, setRefresh } = props;

	const handleChange = (element, lang) => (event) => {
		if (event.target.value === " ") return;
		if (!lang) {
			setUserDiet({...userDiet, [element]: event.target.value})
		}
		setRefresh(true);
	};

    function formatGastro(value) {
        switch (parseFloat(value)) { 
            case 1: return '😢';
            case 2: return '😟';
            case 3: return '😐';
            case 4: return '🙂';
            case 5: return '😄';
            default: return null;
        }
    }

    return (
        <Card>
            <CardBody>
                <Row>
                    <Col>
                        <TextField
                            id={`notes`}
                            label="Private notes"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            onChange={handleChange('privateNotes', false)}
                            value={userDiet?.privateNotes}
                            margin="normal"
                            variant="standard"
                            placeholder="Enter notes for the patient..."
                            type="text"
                            multiline
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <TextField
                            id={`notes`}
                            label="Public notes"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            onChange={handleChange('publicNotes', false)}
                            value={userDiet?.publicNotes}
                            margin="normal"
                            variant="standard"
                            placeholder="Enter notes for the patient..."
                            type="text"
                            multiline
                        />
                    </Col>
                </Row>
                {/* <Row>
                    <Col>
                        <TextField
                            id={`patientNotes`}
                            label="Patient notes"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            value={(userDiet?.patientNotes)}
                            margin="normal"
                            variant="standard"
                            className='readonly'
                            placeholder="Not defined..."
                            type="text"
                            multiline
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <TextField
                            id={`gastroentinals`}
                            label="Gastroentinals (😢😟😐🙂😄)"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            value={formatGastro(userDiet?.gastrointestinalSymptoms)}
                            margin="normal"
                            variant="standard"
                            className='readonly'
                            placeholder="Not defined..."
                            type="text"
                            multiline
                        />
                    </Col>
                </Row> */}
                <br/> <br/> <br/> <br/> <br/> <br/> <br/> <br/>
                <br/> <br/> <br/> <br/>
            </CardBody>
        </Card>
    )
} 